exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".privatePage-b343c303{padding:45px 120px}.card-dff90c55{max-width:720px;max-height:300px}.icon-247e47fa{color:#757575;height:84px;width:84px;display:flex;align-items:center;justify-content:center;margin-bottom:20px}.buttons-9e37756c{margin-top:20px}\n", ""]);

// Exports
exports.locals = {
	"privatePage": "privatePage-b343c303",
	"card": "card-dff90c55",
	"icon": "icon-247e47fa",
	"buttons": "buttons-9e37756c"
};